import * as React from "react"

import { createNavigator, MoveHandle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderFunction, NavigatorProps } from "Catalog/Edit/shared/components/Navigator/types"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { DiscountId } from "shared/hubrise/ids"
import { IDiscount } from "shared/hubrise/models"

import { StyledDiscount, Name } from "./Styles"

interface DiscountProps {
  items: Array<IDiscount>
  selectedId?: DiscountId
}

const DiscountNavigator = createNavigator<IDiscount>()

const Navigator = ({ items, selectedId }: DiscountProps): JSX.Element => {
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const selectItem = React.useCallback(
    (discount: IDiscount): void => navigate(catalogNavigation.editPath("discount", discount.id)),
    [catalogNavigation, navigate],
  )

  const moveItem: NavigatorProps<IDiscount>["moveItem"] = React.useCallback(
    (item, newPosition) => editor.discount.move(item, newPosition),
    [editor],
  )

  const renderItem: ItemRenderFunction<IDiscount> = React.useCallback(
    (item, itemRenderProps) => (
      <StyledDiscount {...itemRenderProps}>
        <Name>{item.name}</Name>
        <MoveHandle {...itemRenderProps} />
      </StyledDiscount>
    ),
    [],
  )

  return <DiscountNavigator {...{ items, selectItem, selectedId, moveItem, renderItem }} />
}

export default Navigator
